
export const FETCH_NEWS = 'FETCH_NEWS'
export const FETCH_NEWS_SUCCESS = 'FETCH_NEWS_SUCCESS'
export const FETCH_NEWS_FAILURE = 'FETCH_NEWS_FAILURE'


export const fetchNews = (id) => ({
    type: FETCH_NEWS,
    payload: id
})

export const fetchNewsSuccess = (news) => ({
    type: FETCH_NEWS_SUCCESS,
    payload: news
})

export const fetchNewsFailed = (message) => ({
    type: FETCH_NEWS_FAILURE,
    payload: message
})